import type { PrivateXModulesOptions, XModulesOptions } from '@empathyco/x-components'
import type { InternalSearchRequest, SearchState } from '@empathyco/x-components/search'
import { saveSearchResponse } from './actions/save-search-response.action'
import { searchWiring } from './search.wiring'

export const searchOptions: XModulesOptions['search'] = {
  wiring: searchWiring,
}

export const searchPrivateOptions: PrivateXModulesOptions['search'] = {
  storeModule: {
    state: {
      isFacetsAsideOpen: false,
      oldRequest: null,
    },
    mutations: {
      setIsFacetsAsideOpen(state: SearchState, isFacetsAsideOpen: boolean) {
        state.isFacetsAsideOpen = isFacetsAsideOpen
      },
      setOldRequest(state: SearchState, oldRequest: InternalSearchRequest | null) {
        state.oldRequest = oldRequest
      },
    },
    actions: {
      saveSearchResponse,
    },
  },
  storeEmitters: {
    SearchRequestUpdated: {
      selector: (_, getters) => getters.request,
      filter(newValue, oldValue, state) {
        return !state.isFacetsAsideOpen
      },
    },
  },
}
